var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckoutPageStoreWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0002 12.6201V14.6801C22.0002 15.2401 21.5402 15.7001 20.9702 15.7001H19.0402C17.9602 15.7001 16.9702 14.9101 16.8802 13.8301C16.8202 13.2001 17.0602 12.6101 17.4802 12.2001C17.8502 11.8201 18.3602 11.6001 18.9202 11.6001H20.9702C21.5402 11.6001 22.0002 12.0601 22.0002 12.6201Z",
    fill: "#50429B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.38 13.9599C15.29 12.9099 15.67 11.8799 16.43 11.1299C17.07 10.4799 17.96 10.0999 18.92 10.0999H19.49C19.77 10.0999 20 9.8699 19.96 9.5899C19.69 7.6499 18.01 6.1499 16 6.1499H6C3.79 6.1499 2 7.9399 2 10.1499V17.1499C2 19.3599 3.79 21.1499 6 21.1499H16C18.02 21.1499 19.69 19.6499 19.96 17.7099C20 17.4299 19.77 17.1999 19.49 17.1999H19.04C17.14 17.1999 15.54 15.7799 15.38 13.9599ZM13 11.8999H7C6.59 11.8999 6.25 11.5699 6.25 11.1499C6.25 10.7299 6.59 10.3999 7 10.3999H13C13.41 10.3999 13.75 10.7399 13.75 11.1499C13.75 11.5599 13.41 11.8999 13 11.8999Z",
    fill: "#50429B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2097 3.9801C14.4697 4.2501 14.2397 4.6501 13.8597 4.6501H6.02966C4.93966 4.6501 3.91966 4.9701 3.06966 5.5201C2.67966 5.7701 2.14966 5.5001 2.33966 5.0701C2.89966 3.7601 4.20966 2.8501 5.71966 2.8501H11.3397C12.4997 2.8501 13.5297 3.2601 14.2097 3.9801Z",
    fill: "#50429B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckoutPageStoreWeb);
export default __webpack_public_path__ + "static/media/checkout-page-store-web.a5a3bb6be7ec31ea40a8ca3df5b4cd2b.svg";
export { ForwardRef as ReactComponent };